import React from 'react';
import cx from 'classnames';
import {
  Icon,
  Image,
  NavigationLink,
  Text,
  LOGO_CONTAINER,
  LOGO,
  TOP_MENU_LINKS,
  BOTTOM_MENU_LINKS,
  EXIT_MENU_LINKS
} from '@shootsta/common-react';
import '../styles/_nav-menu-admin.scss';

export type Route = {
  label: string,
  icon?: string,
  url?: string,
  selected?: boolean,
  className?: string,
  onClick?: Function,
}

type NavigationMenuAdminProps = {
  topRoutes: Array<Route>,
  bottomRoutes?: Array<Route>,
  history: Object,
  logoUrl?: string,
  primaryLinksColour?: string,
  primaryLinksHoverColour?: string,
  primaryLinksSelectedColour?: string,
  hasLogo?: boolean,
  exitRoute: Route
};

const NavigationMenuAdmin = ({
  topRoutes,
  bottomRoutes,
  history,
  logoUrl,
  primaryLinksColour,
  primaryLinksHoverColour,
  primaryLinksSelectedColour,
  hasLogo,
  exitRoute
}: NavigationMenuAdminProps) => {
  const renderNavLink = (exit = false) => ({
    label,
    icon,
    url,
    selected,
    onClick,
    className
  }: Route) => (
    <NavigationLink
      key={icon}
      onClick={onClick || (() => history.push(url))}
      label={label}
      selected={selected}
      icon={icon}
      className={className}
      linkColour={exit ? 'navMenuLabel' : primaryLinksColour}
      linkHoverColor={primaryLinksHoverColour}
      linkSelectedColor={primaryLinksSelectedColour}
      admin
      exit={exit}
    />
  );

  const goToHome = () => {
    history.push('/');
  };

  return (
    <div className="nav-admin__menu-container">
      <div className="nav-admin__menu-wrapper">
        {hasLogo && (
          <div className={cx('nav-admin__menu__logo', LOGO_CONTAINER(true))}>
            <div className={LOGO(true)} style={{ color: primaryLinksColour }}>
              {
                logoUrl
                  ? <Image width="35px" height="35px" imageUrl={logoUrl} backgroundSize="cover" />
                  : <Icon name="shootstacolour" size={35} />
              }
              <Text label noMargin>Admin</Text>
            </div>
          </div>
        )}
        <div className={cx('nav-admin__menu__top-links', TOP_MENU_LINKS(true))}>
          {topRoutes.map(renderNavLink())}
        </div>
        {
          bottomRoutes
            ? (
              <div className={cx('nav-admin__menu__bottom-links', BOTTOM_MENU_LINKS(true))}>
                {bottomRoutes.map(renderNavLink())}
              </div>
            )
            : null
        }
        {exitRoute && (
          <div className={cx('nav-admin__menu__exit-links', EXIT_MENU_LINKS)}>
            <div className="nav-admin__menu__exit-divider" />
            {renderNavLink(true)({
              ...exitRoute
            })}
          </div>
        )}
      </div>
    </div>
  );
};

NavigationMenuAdmin.displayName = 'NavigationMenuAdmin';
NavigationMenuAdmin.defaultProps = {
  hasLogo: true
};

export default NavigationMenuAdmin;
